import React from 'react'
import { Form } from 'semantic-ui-react'

export default class NameField extends React.PureComponent {
  render() {
    const { value, onChange, label, field } = this.props

    return (
      <Form.Input
        fluid
        label={label}
        placeholder="e.g Muuve Driver"
        required
        onChange={e => onChange(field, e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/nameField.js